import { mockState, state } from '@/store/cache/state';
import { actions } from '@/store/cache/actions';
import { mutations } from '@/store/cache/mutations';
import { getters } from '@/store/cache/getters';

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

export { state, mockState, mutations, actions, getters };
